import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import {
  Home,
  Search,
  FileText,
  Truck,
  User,
  Bell,
  LogOut,
} from 'lucide-react';

const navItems = [
  { icon: Home, labelKey: 'nav.home', path: '/' },
  { icon: Search, labelKey: 'nav.marketplace', path: '/marketplace' },
  { icon: FileText, labelKey: 'nav.contracts', path: '/contracts' },
  { icon: Truck, labelKey: 'nav.provider', path: '/provider' },
  { icon: User, labelKey: 'nav.profile', path: '/profile' },
];

export const MobileLayout = ({ children }) => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Top header bar */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-40 pt-safe">
        <div className="flex items-center justify-between h-14 px-4">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 bg-primary-500 rounded-lg flex items-center justify-center">
              <Truck className="h-4 w-4 text-white" />
            </div>
            <span className="text-base font-semibold text-gray-900">
              {t('common.appName')}
            </span>
          </div>

          <div className="flex items-center gap-1">
            <button
              onClick={() => navigate('/notifications')}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors relative"
              aria-label={t('nav.notifications')}
            >
              <Bell className="h-5 w-5 text-gray-600" />
            </button>
            <button
              onClick={async () => {
                await logout();
                navigate('/login');
              }}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              aria-label={t('auth.logout')}
            >
              <LogOut className="h-5 w-5 text-gray-600" />
            </button>
          </div>
        </div>
      </header>

      {/* Main content area */}
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>

      {/* Bottom navigation */}
      <nav className="bg-white border-t border-gray-200 sticky bottom-0 z-40 pb-safe">
        <div className="flex items-center justify-around h-16">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 px-3 py-1 rounded-lg transition-colors min-w-0 ${
                  isActive
                    ? 'text-primary-600'
                    : 'text-gray-500 hover:text-gray-700'
                }`
              }
            >
              <item.icon className="h-5 w-5 flex-shrink-0" />
              <span className="text-[10px] font-medium truncate">
                {t(item.labelKey)}
              </span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
};
